import React, { useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router';
import WelcomeSlider from '../WelcomeSlider/WelcomeSlider';
import { completedRoutes } from '../../common/constants';
import { get } from 'lodash';

export default function WelcomePage(props) {
  const { setFirstVisit } = props;
  const history = useHistory();
  const referrerUrl = get(history.location, 'state.referrer', '/');

  const handleOk = () => {
    history.replace(referrerUrl);
  }

  useEffect(() => {
    setFirstVisit(false)
  });

  return (
    <Switch>
      <Route path={completedRoutes.welcome}>
        <WelcomeSlider {...props} handleOk={handleOk} />
      </Route>
    </Switch>
  );
}
